{
    "RandomiseTitle": "Randomizzare la password",
    "PasswordStrength": "Forza della password:",
    "PasswordStrength_0": "Troppo breve",
    "PasswordStrength_1": "Molto debole",
    "PasswordStrength_2": "Debole",
    "PasswordStrength_3": "Moderato",
    "PasswordStrength_4": "Forte",
    "PasswordStrength_5": "Molto forte",
    "NAME": "PasswordTextInput",
    "PasswordRequirements_Title": "Requisiti della password:"
}